'use strict';

var React = require('react');

var SvgForkliftIcon = function SvgForkliftIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M15 4.25a.75.75 0 0 0-1.5 0v3.98l-.8-2.001a2.75 2.75 0 0 0-2.554-1.729h-3.396a.75.75 0 0 0-.75.75v3.25h-1.75a.75.75 0 0 0-.75.75v3.159a2.5 2.5 0 1 0 4.636 1.841h2.479a2.501 2.501 0 0 0 4.835-1.25h1.8a.75.75 0 0 0 0-1.5h-2.25v-7.25Zm-8.589 10a.998.998 0 0 0 0-1.5.996.996 0 0 0-1.322 0 .998.998 0 0 0 0 1.5.996.996 0 0 0 1.322 0Zm-1.411-3.136a2.501 2.501 0 0 1 3.136 1.636h2.479a2.502 2.502 0 0 1 2.135-1.738v-.012h-3.25a.75.75 0 0 1-.256-.045l-2.626-.955h-1.618v1.114Zm7.338 1.636a1 1 0 1 1 1.323 1.498 1 1 0 0 1-1.322-1.498Zm-2.706-3.25h2.76l-1.085-2.714a1.25 1.25 0 0 0-1.161-.786h-2.646v2.725l2.132.775Z"
  }));
};
SvgForkliftIcon.displayName = "ForkliftIcon";

exports.SvgForkliftIcon = SvgForkliftIcon;
